function extractHourFromPtPt(str) {
  const regex = /às (\d{2}):(\d{2}):(\d{2})/;
  const match = str.match(regex);

  if (!match) return null;

  const [, hour, minute] = match;

  return `${hour}:${minute}`;
}

export function parseDateFlexible(date) {
  if (!date) return null;

  // Se já é Date
  if (date instanceof Date) return date;

  // Se já é ISO / timestamp
  const iso = new Date(date);
  if (!isNaN(iso.getTime())) return iso;

  // Se for pt-PT formatado
  if (typeof date === "string") {
    const regex =
      /(\d{1,2}) de ([a-zç]+) de (\d{4}) às (\d{2}):(\d{2}):(\d{2})/i;

    const months = {
      janeiro: 0,
      fevereiro: 1,
      março: 2,
      abril: 3,
      maio: 4,
      junho: 5,
      julho: 6,
      agosto: 7,
      setembro: 8,
      outubro: 9,
      novembro: 10,
      dezembro: 11
    };

    const match = date.match(regex);
    if (!match) return null;

    const [, day, month, year, hour, minute, second] = match;

    return new Date(
      Number(year),
      months[month.toLowerCase()],
      Number(day),
      Number(hour),
      Number(minute),
      Number(second)
    );
  }

  return null;
}

function formatToPtPt(date) {
  const d = new Date(date);
  if (isNaN(d.getTime())) return null;

  return d.toLocaleString("pt-PT", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
}

export function getCurrentDateTime(dateTime) {

   if (dateTime != null) {
     return dateTime.substring(11, 16);
  }

}

export function getHora(dateTime) {
  if (!dateTime) return "";

  return dateTime.substring(11, 16);
}

export function formatDate(dateStr, source = "fetch") {
 
  
        if (!dateStr) return null;
        const date = new Date(dateStr);

        
        if (isNaN(date.getTime())) return null;


        const timeZone =
          source === "socket"
            ? "Europe/Lisbon"
            : "Europe/Lisbon";

        
        if (typeof dateStr === "string" && /[a-zA-ZçÇáéíóúàâêôãõ]/.test(dateStr) && !dateStr.includes("T")) {
          return  extractHourFromPtPt(dateStr);
        
        }   


        return date.toLocaleTimeString("pt-PT", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
          timeZone
        });
   
}





export function formatDate2(dateStr) {


  if (!dateStr) return "";

  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";

  return date.toLocaleTimeString("pt-PT", {
    timeZone: "Europe/Lisbon",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function formatFirstLastName(fullName) {
  if (!fullName) return "";

  const parts = fullName.trim().split(" ");
  const first = parts[0];
  const last = parts.length > 1 ? parts[parts.length - 1] : "";


  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  return `${capitalize(first)} ${capitalize(last)}`;
}


export function arrayBufferToBase64(buffer) {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;

  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
}

export const isBase64Image = (str) => {
  if (!str) return false;

  if (str.startsWith("data:image")) return true;


  const base64Regex = /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/;

  return base64Regex.test(str);
};


export const formatLogo = (logo) => {
  if (!logo?.data) return null;

  return `data:image/jpeg;base64,${btoa(
    new Uint8Array(logo.data).reduce(
      (data, byte) => data + String.fromCharCode(byte),
      ""
    )
  )}`;
};

export const formatDateAGEND = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};


export const getLogo = (logo) => {
  if (!logo) return null;

  if (typeof logo !== "string") return null;

  if (logo.startsWith("https")) return logo;

  if (logo.startsWith("data:image")) return logo;

  return null;
};


export const getLastMessagePreview = (msg) => {
  if (!msg) return "Sem mensagens";

  const isUrl = msg.startsWith("https");

  if (!isUrl) return msg;

  const isImage = msg.match(/\.(jpeg|jpg|png|gif|webp)$/i);
  const isVideo = msg.match(/\.(mp4|mov|avi|webm)$/i);

  if (isImage) return "🖼️ Imagem";
  if (isVideo) return "🎥 Vídeo";

  return "📎 Ficheiro";
};


const resolveMensagem = (value) => {
  if (typeof value === "string") return value;
  if (!value) return "";
  if (typeof value === "object") {
    return value.mensagem || value.MENSAGEM || "";
  }
  return String(value);
};

export const formatCobrancaMensagem = (conteudo) => {
  if (!conteudo) return { fase: "", faseLabel: "", mensagem: "" };

  let obj = conteudo;

  if (typeof conteudo === "string") {
    try {
      obj = JSON.parse(conteudo);
    } catch {
      return { fase: "", faseLabel: "", mensagem: conteudo };
    }
  }

  const fase = obj?.fase;

  const faseLabelMap = {
    ANTES: "Antes do vencimento",
    DIA: "Dia do vencimento",
    ATRASO: "Em atraso"
  };

  const templates = obj?.templates || obj;

  const mensagem =
    resolveMensagem(templates?.[fase]) ||
    resolveMensagem(templates?.ANTES) ||
    resolveMensagem(templates?.DIA) ||
    resolveMensagem(templates?.ATRASO) ||
    (typeof obj?.mensagem === "string" ? obj.mensagem : "");

  return {
    fase,
    faseLabel: faseLabelMap[fase] || fase,
    mensagem
  };
};




